import React, { useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";

export default function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
    nickname: "",
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const recaptchaRef = useRef();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Honeypot check
    if (formData.nickname) {
      console.warn("Spam bot detected – ignoring submission.");
      return;
    }

    setLoading(true);

    try {
      // ✅ Use formData.message, not message
      const response = await fetch("https://api.smartguytechnologies.com/api/send", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          to: "JTerry@smartguytechnologies.com",
          subject: `Smartguy Contact Form - ${formData.name}`,
          body: `Name: ${formData.name}\nEmail: ${formData.email}\n\nMessage:\n${formData.message}`,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error || `HTTP ${response.status}`);
      }

      setSubmitted(true);
      setFormData({ name: "", email: "", message: "", nickname: "" });
    } catch (error) {
      console.error("Form submission error:", error);
      alert("❌ There was a problem submitting the form. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contact" className="py-12 border-t bg-orange-600">
      <h2 className="text-3xl font-bold mb-6 text-black-700 text-center">
        Contact Us Today
      </h2>

      {submitted ? (
        <p className="text-green-600 text-center text-xl">
          ✅ Thanks! We'll be in touch soon.
        </p>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-4 max-w-lg mx-auto">
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            required
            onChange={handleChange}
            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:outline-none"
          />
          <input
            type="email"
            name="email"
            placeholder="Your Email"
            value={formData.email}
            required
            onChange={handleChange}
            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:outline-none"
          />
          <textarea
            name="message"
            placeholder="Your Message"
            value={formData.message}
            required
            rows="4"
            onChange={handleChange}
            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:outline-none"
          ></textarea>

          {/* Honeypot field */}
          <input
            type="text"
            name="nickname"
            value={formData.nickname}
            onChange={handleChange}
            className="hidden"
            autoComplete="off"
          />

          <ReCAPTCHA
            sitekey="6Ler_swZAAAAAAyyympc_0GiHmp7bBpY83aIY2SX"
            size="invisible"
            ref={recaptchaRef}
          />

          <button
            type="submit"
            disabled={loading}
            className={`w-full px-6 py-3 font-semibold rounded-md transition ${
              loading
                ? "bg-gray-400 text-white cursor-not-allowed"
                : "bg-neutral-900 text-white hover:bg-white hover:text-black"
            }`}
          >
            {loading ? "Sending..." : "Send Message"}
          </button>
        </form>
      )}
    </section>
  );
}
